import { useAsync } from '@sit/client-shared';
import { invalidateIdb } from '../helpers/invalidate-idb';
import { useTokenFragment } from './useTokenFragment';

export function useCacheBustIndexDbIfDifferentUser(): {
  data: void | null;
  loading: boolean;
  error: Error | null;
} {
  const token = useTokenFragment();
  return useAsync(() => invalidateIdb(token), [token]);
}
